import { ReactSDKClient } from '@optimizely/react-sdk';
import useOptimizely from 'shared/hooks/optimizely/useOptimizely';

export const useDevelopmentDetails = (optimizely: ReactSDKClient | null) =>
    useOptimizely(optimizely, 'development_details_ldp');
